import { IPartner } from "../../types/partners.type";
import { PaymentInfo } from "../../types/payment.type";
import { PartnerInfoType } from "../../types/vehicle.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = `${import.meta.env.VITE_API_URL}/partners`;
type SaveCertificateData = {
  partnersId: string;
  certificate: string;
  password_certificate: string;
};
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getPartners({
  status = "",
  state = "",
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "-updatedAt",
  fields = "status, cnpj, companyName, fantasyName, owner, operationalContact, updatedAt, createdAt, certificate",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  status && params.append("filters[status]", status);
  state && params.append("filters[address.state]", state);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString(),
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString(),
    );
  // orderBy && params.append("orderBy", sortConfig ? `-${sortConfig}` : "-updatedAt");
  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPartner[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

const removeReadonlyId = (updatedData) => {
  delete updatedData._id;
};
export async function saveDigitalCertificate(data: SaveCertificateData) {
  const { partnersId, ...rest } = data;
  const url = `${API_URL}/${partnersId}/digital-certificate`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(rest),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPartner>
  >;
}
export async function createPartners(partnersData: IPartner) {
  removeReadonlyId(partnersData);
  if (partnersData.partnersType == "partner_out") {
    const dataCompany = {
      socialname: partnersData.companyName,
      fantasyname: partnersData.fantasyName,
      cnpj: partnersData.cnpj,
      email: partnersData.email,
      phone: partnersData.operationalContact.phone,
      address: partnersData.address,
    };
    const url = `${API_URL}/companies`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataCompany),
    };
    return makeRequestDebounced(url, options) as Promise<
      ApiResponseType<IPartner>
    >;
  } else {
    const dataPartner = {
      ...partnersData,
      companyId: getCompanyId(),
    };
    const url = `${API_URL}/`;
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataPartner),
    };
    return makeRequestDebounced(url, options) as Promise<
      ApiResponseType<IPartner>
    >;
  }
}

export async function getPartnersById(partnersId: string) {
  const url = `${API_URL}/${partnersId}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<IPartner>
  >;

  return result;
}

const makeRequestByWalletId = createDebounce(makeRequest, 200);
export async function getPartnersByWalletId(walletId: string) {
  const url = `${API_URL}/wallets/${walletId}`;

  const result = (await makeRequestByWalletId(url)) as Promise<
    ApiResponseType<IPartner>
  >;

  return result;
}

export async function getPartnersFiltered({
  fields = "companyName",
  orderBy = "companyName",
  itemsPerPage = 100,
  companyId = "",
} = {}) {
  const params = new URLSearchParams({
    fields,
    itemsPerPage: String(itemsPerPage),
    companyId,
  });

  if (orderBy) {
    params.append("orderBy", orderBy);
  }

  // if (companyId) {
  //   params.append("filters[companyId]", companyId);
  // }

  const url = `${API_URL}/?${params.toString()}`;
  return makeRequest<PartnerInfoType[]>(url);
}

const removeReadonlyFields = (updatedData) => {
  //delete updatedData._id;
  delete updatedData.__v;
  delete updatedData.contacts;
  delete updatedData.pendencies;
  delete updatedData.status;
  delete updatedData.updatedAt;
  delete updatedData.createdAt;
};

export async function updatePartners(id: string, updatedData) {
  removeReadonlyFields(updatedData);

  const url = `${API_URL}/${id}`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPartner>
  >;

  return result;
}

export function getPartnerPayments(partneId) {
  const url = `${API_URL}/${partneId}/payments`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}
export async function updatePartnerStatus(
  partnerId: string,
  status: "active" | "defaulter",
) {
  const url = `${API_URL}/${partnerId}/status`;

  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPartner>
  >;
}
